import React from "react";

export const CloseIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_427_1388)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.4194 3.58058C12.7123 3.87347 12.7123 4.34835 12.4194 4.64124L9.06066 8L12.4194 11.3588C12.7123 11.6516 12.7123 12.1265 12.4194 12.4194C12.1265 12.7123 11.6517 12.7123 11.3588 12.4194L8 9.06066L4.64124 12.4194C4.34835 12.7123 3.87348 12.7123 3.58058 12.4194C3.28769 12.1265 3.28769 11.6516 3.58058 11.3588L6.93934 8L3.58058 4.64124C3.28769 4.34835 3.28769 3.87347 3.58058 3.58058C3.87348 3.28769 4.34835 3.28769 4.64124 3.58058L8 6.93934L11.3588 3.58058C11.6517 3.28769 12.1265 3.28769 12.4194 3.58058Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_427_1388">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ArrowIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.75 8C14.75 8.41421 14.4142 8.75 14 8.75L3.81066 8.75L6.53033 11.4697C6.82323 11.7626 6.82323 12.2374 6.53033 12.5303C6.23744 12.8232 5.76256 12.8232 5.46967 12.5303L1.46967 8.53033C1.17678 8.23744 1.17678 7.76256 1.46967 7.46967L5.46967 3.46967C5.76256 3.17678 6.23744 3.17678 6.53033 3.46967C6.82323 3.76256 6.82323 4.23744 6.53033 4.53033L3.81066 7.25L14 7.25C14.4142 7.25 14.75 7.58579 14.75 8Z"
        fill="var(--text-light)"
      />
    </svg>
  );
};

export const CopyIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="9" y="9" width="13" height="13" rx="2" />
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </svg>
  );
};

export const HeaderIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#1a0f00"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
};

export const NoReferalsIcon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4163 22.75V20.5833C18.4163 19.4341 17.9598 18.3319 17.1471 17.5192C16.3345 16.7065 15.2323 16.25 14.083 16.25H5.41634C4.26707 16.25 3.16487 16.7065 2.35221 17.5192C1.53955 18.3319 1.08301 19.4341 1.08301 20.5833V22.75"
        stroke="#7E7E9A"
        strokeOpacity="0.7"
        strokeWidth="1.95"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75033 11.9167C12.1436 11.9167 14.0837 9.97657 14.0837 7.58333C14.0837 5.1901 12.1436 3.25 9.75033 3.25C7.35709 3.25 5.41699 5.1901 5.41699 7.58333C5.41699 9.97657 7.35709 11.9167 9.75033 11.9167Z"
        stroke="#7E7E9A"
        strokeOpacity="0.7"
        strokeWidth="1.95"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.917 22.7498V20.5831C24.9163 19.623 24.5967 18.6903 24.0085 17.9315C23.4202 17.1726 22.5966 16.6307 21.667 16.3906"
        stroke="#7E7E9A"
        strokeOpacity="0.7"
        strokeWidth="1.95"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.333 3.39062C18.2651 3.62928 19.0913 4.17138 19.6813 4.93146C20.2713 5.69154 20.5915 6.62636 20.5915 7.58854C20.5915 8.55073 20.2713 9.48555 19.6813 10.2456C19.0913 11.0057 18.2651 11.5478 17.333 11.7865"
        stroke="#7E7E9A"
        strokeOpacity="0.7"
        strokeWidth="1.95"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const QrIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <line x1="14" y1="14" x2="14" y2="17" />
      <line x1="14" y1="20" x2="14" y2="21" />
      <line x1="17" y1="14" x2="21" y2="14" />
      <line x1="17" y1="17" x2="17" y2="21" />
      <line x1="20" y1="17" x2="21" y2="17" />
      <line x1="20" y1="20" x2="21" y2="20" />
    </svg>
  );
};

export const SaveIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  );
};

export const ShareIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#1a0f00"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="18" cy="5" r="3" />
      <circle cx="6" cy="12" r="3" />
      <circle cx="18" cy="19" r="3" />
      <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
      <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
    </svg>
  );
};

export const CheckMark = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3925 3.48811C13.9514 2.87681 14.9002 2.8338 15.5117 3.3924C16.123 3.95126 16.166 4.90011 15.6074 5.51154L7.34176 14.5526L1.55758 9.88557C0.912987 9.36529 0.812741 8.42085 1.33298 7.77619C1.85324 7.13153 2.79767 7.03035 3.44235 7.55061L7.03024 10.4471L13.3925 3.48811Z"
        fill="url(#paint0_linear_663_6531)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_663_6531"
          x1="2.49997"
          y1="4.49982"
          x2="9.88458"
          y2="15.5767"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5A623" />
          <stop offset="1" stopColor="#E8743B" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const chevronPoints = {
  down: "6 9 12 15 18 9",
  left: "15 18 9 12 15 6",
  right: "9 18 15 12 9 6",
};

export const ChevronIcon = ({
  direction = "down",
  size = 20,
}: {
  direction?: keyof typeof chevronPoints;
  size?: number;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <polyline points={chevronPoints[direction]} />
    </svg>
  );
};

export const CheckIcon = ({
  size = 13,
  strokeWidth = 3,
}: {
  size?: number;
  strokeWidth?: number;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
};

export const SendIcon = ({
  size = 17,
  strokeWidth = 2.4,
}: {
  size?: number;
  strokeWidth?: number;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  );
};

export const SortIcon = ({ size = 14 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <polyline points="21 16 17 20 13 16" />
      <line x1="17" y1="20" x2="17" y2="4" />
      <polyline points="3 8 7 4 11 8" />
      <line x1="7" y1="4" x2="7" y2="20" />
    </svg>
  );
};

export const RegistrationsIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M5.2002 6.4187C6.32202 6.4187 7.23144 5.50928 7.23144 4.38745C7.23144 3.26562 6.32202 2.3562 5.2002 2.3562C4.07837 2.3562 3.16895 3.26562 3.16895 4.38745C3.16895 5.50928 4.07837 6.4187 5.2002 6.4187Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.54395 10.725C1.54395 8.8562 3.16895 7.7187 5.2002 7.7187C5.8502 7.7187 6.5002 7.84058 7.06895 8.08433M9.9127 7.63745V11.05M8.20645 9.3437H11.6189"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ViewsIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M1.1377 6.50005C1.1377 6.50005 3.2502 2.92505 6.5002 2.92505C9.7502 2.92505 11.8627 6.50005 11.8627 6.50005C11.8627 6.50005 9.7502 10.075 6.5002 10.075C3.2502 10.075 1.1377 6.50005 1.1377 6.50005Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5002 8.2062C7.44253 8.2062 8.20645 7.44229 8.20645 6.49995C8.20645 5.55762 7.44253 4.7937 6.5002 4.7937C5.55786 4.7937 4.79395 5.55762 4.79395 6.49995C4.79395 7.44229 5.55786 8.2062 6.5002 8.2062Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ContestPositionArrowIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M8 2.80005L8 13.2M4 9.20005L8 13.2L12 9.20005"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TgLogoIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1801_1975)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25434 8.52116L9.60891 5.86004C9.96235 5.64405 10.424 5.75547 10.64 6.10891C10.856 6.46235 10.7445 6.92397 10.3911 7.13996L6.58638 9.46506L9.77013 12.6488C9.99499 12.8737 10.3 13 10.618 13C11.1203 13 11.5694 12.6868 11.7431 12.2155L14.4355 4.90751C14.4782 4.79174 14.5 4.66932 14.5 4.54593C14.5 3.96828 14.0317 3.5 13.4541 3.5H13.3504C13.2495 3.5 13.149 3.51329 13.0516 3.53953L2.02287 6.50879C1.71438 6.59185 1.5 6.87158 1.5 7.19106C1.5 7.52786 1.73773 7.81784 2.06799 7.88389L5.25434 8.52116ZM1.77382 9.35476L5 10L8.70947 13.7095C9.21564 14.2156 9.90215 14.5 10.618 14.5C11.7488 14.5 12.7597 13.7951 13.1506 12.734L15.843 5.42607C15.9469 5.14425 16 4.84627 16 4.54593C16 3.13985 14.8601 2 13.4541 2H13.3504C13.1178 2 12.8862 2.03063 12.6616 2.0911L1.63291 5.06037C0.669497 5.31975 0 6.19334 0 7.19106C0 8.24288 0.742418 9.14848 1.77382 9.35476Z"
        fill="#1A0F00"
      />
    </g>
    <defs>
      <clipPath id="clip0_1801_1975">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
